import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import UserEvicted from "./UserEvicted";
import { selectSessionStatus } from "COMPONENTS/Dashboard/selectors";
import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";

export class UserEvictedContainer extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount(){
    history.pushState(null, null, location.href);
    window.onpopstate = function(event) {
      history.go(1);
    }; 
  }
  onSelectChange = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
  };

  render() {
    return (
      <React.Fragment>
        <UserEvicted
          onSelectChange={this.onSelectChange}
          language={this.props.language}
          userSessionName={this.props.userSessionName}
          sessionStatus={this.props.sessionStatus}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.LanguageReducer.language,
    sessionStatus: selectSessionStatus(state),
    userSessionName: state.SessionReducer.sessionDetails.sessionName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setLanguageAction
  }, dispatch);
};

export default withErrorHandler(
  connect(mapStateToProps, mapDispatchToProps)(UserEvictedContainer)
);
